<!-- Modal Backdrop -->
<div class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" (click)="close()">
  <!-- Modal Box -->
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col m-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b border-base-300">
      <h3 class="text-lg font-bold">Artikelvorlage auswählen</h3>
      <div class="flex items-center gap-2">
        <a
          href="/a/artikelvorlagen/neu"
          target="_blank"
          class="bm-btn bm-btn-sm bm-btn-primary"
        >
          <i class="fa fa-plus mr-1"></i> Neue Vorlage
        </a>
        <button
          type="button"
          class="bm-btn bm-btn-sm bm-btn-ghost"
          (click)="reloadTemplates()"
          title="Vorlagen aktualisieren"
        >
          <i class="fa fa-refresh" [class.fa-spin]="isLoading"></i>
        </button>
        <button class="bm-btn bm-btn-sm bm-btn-ghost bm-btn-square" (click)="close()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Suche und Filter -->
    <div class="p-4 border-b border-base-300 space-y-3">
      <!-- Suchfeld -->
      <input
        type="text"
        class="bm-input w-full"
        placeholder="Suchen nach Beschreibung, Artikelnummer, Hersteller..."
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearchChange($event)"
      />

      <!-- Filter -->
      <div class="flex flex-wrap gap-4">
        @if (sourceWarehouse && warehouseArticleTemplateIds) {
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              class="checkbox checkbox-sm"
              [ngModel]="filterByWarehouse()"
              (ngModelChange)="toggleWarehouseFilter()"
            />
            <span class="text-sm">
              <i class="fa fa-warehouse mr-1 text-base-content/60"></i>
              Im Lager: {{ sourceWarehouse.label }}
            </span>
          </label>
        }
        @if (project) {
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              class="checkbox checkbox-sm"
              [ngModel]="filterByProject()"
              (ngModelChange)="toggleProjectFilter()"
            />
            <span class="text-sm">
              <i class="fa fa-folder mr-1 text-base-content/60"></i>
              Projekt: {{ project.name }}
            </span>
          </label>
        }
        @if (customer) {
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              class="checkbox checkbox-sm"
              [ngModel]="filterByCustomer()"
              (ngModelChange)="toggleCustomerFilter()"
            />
            <span class="text-sm">
              <i class="fa fa-user mr-1 text-base-content/60"></i>
              Kunde: {{ customer.name }}
            </span>
          </label>
        }
      </div>

      <!-- Ergebnis-Info -->
      <div class="text-sm text-base-content/60">
        {{ filteredTemplates().length }} von {{ articleTemplates.length }} Artikelvorlagen
      </div>
    </div>

    <!-- Liste -->
    <div class="flex-1 overflow-y-auto p-4">
      @if (isLoading) {
        <div class="flex justify-center py-8">
          <span class="loading loading-spinner loading-md"></span>
        </div>
      } @else if (filteredTemplates().length === 0) {
        <div class="py-8 text-center text-base-content/60">
          <i class="fa fa-search text-3xl mb-2"></i>
          <p>Keine Artikelvorlagen gefunden.</p>
          @if (filterByProject() || filterByCustomer()) {
            <p class="text-sm mt-1">Versuchen Sie, die Filter zu entfernen.</p>
          }
        </div>
      } @else {
        <div class="space-y-2">
          @for (template of visibleTemplates(); track template.id) {
            <div
              class="w-full p-3 border border-base-300 rounded-lg hover:bg-base-200 transition-colors cursor-pointer"
              (click)="selectTemplate(template)"
            >
              <p class="font-medium">{{ template.description }}</p>
              <div class="flex gap-3 text-xs text-base-content/60 mt-1">
                @if (template.part_nr) {
                  <span>Art.-Nr.: {{ template.part_nr }}</span>
                }
                @if (template.vendor) {
                  <span>Hersteller: {{ template.vendor }}</span>
                }
                @if (template.sn) {
                  <span class="text-info">SN-Pflicht</span>
                }
              </div>
            </div>
          }
        </div>

        <!-- Mehr anzeigen -->
        @if (hasMoreTemplates()) {
          <div class="text-center mt-4">
            <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost w-full" (click)="showMore()">
              <i class="fa fa-chevron-down mr-2"></i>
              Mehr anzeigen ({{ remainingCount() }} weitere)
            </button>
          </div>
        }
      }
    </div>
  </div>
</div>
